import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { SessionService } from '../services/session.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let _req: HttpRequest<any>;

        if (req.url.includes("/auth/login") || req.url.includes("/auth/login_mp") || req.method === 'OPTIONS') {
            _req = req;            
        } else {
            const auth = this.injector.get(SessionService);
            const authToken = auth.getToken();
            const _tokenManagement = auth.getTokenManagement();

            let _token = '';

            if(_tokenManagement !== null){
                _token = `Entry_MP ${_tokenManagement}`;
            }else{
                _token = `Bearer ${authToken}`;
                
            }        

            _req = req.clone({ headers: req.headers.set('Authorization', _token) });
        }

        return next.handle(_req).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                // process successful responses here
            }
        }, (error: any) => {
            if (error instanceof HttpErrorResponse) {                
                if(error.status === 401){
                    const _authService = this.injector.get(AuthService);
                    if(_authService.isAuthenticateManagement()){
                        _authService.logOutAccessMP();
                    }else{
                        if(_authService.isAuthenticate()){
                            _authService.logOut();
                        }
                        
                    }                    
                }           
               
            }
        });

    }

}


// WEBPACK FOOTER //
// /app/src/app/shared/security/auth.Interceptor.ts